module.exports = __webpack_public_path__ + "static/media/NoActivities.e3e73ac9.svg";